import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

import Context from "../contexts/data";

// Funnel answers live only in React state, and every step is directly
// routable, so a webview that evicts and restores the page mid-funnel (seen
// on the Google Search App on iOS) reboots the SPA at the current step with
// empty state. The session then never revisits the Age step and submits
// ownerage="" — the intake drops the empty param and boberdoo scores a
// missing Borrower_Age as 0, which fails every reverse filter's 62+ floor,
// so the lead can only ever be an unmatched $0. Bounce empty-age sessions
// back to the Age step instead.
//
// allowAgeZipParams: the /home-value deep link (?age=&zip=) is a legitimate
// empty-state entry — HomeAmount's own effect validates the params and
// populates age/zip (or diverts), so it must not be bounced.
const RequireAge = ({ allowAgeZipParams = false, children }) => {
  const { age, fullQueryString } = React.useContext(Context);
  const location = useLocation();

  let allowed = age !== "";

  if (!allowed && allowAgeZipParams) {
    const params = new URLSearchParams(location.search);
    allowed = Boolean(params.get("age") && params.get("zip"));
  }

  useEffect(() => {
    if (!allowed) {
      window.dataLayer.push({
        guard_path: location.pathname,
        event: "stateGuardRedirect",
      });
    }
  }, [allowed, location.pathname]);

  if (!allowed) {
    // Same search every internal navigate() uses, so the paid-lane params
    // survive the bounce.
    return <Navigate to={{ pathname: "/", search: fullQueryString }} replace />;
  }

  return children;
};

export default RequireAge;
